import { intersection, redoColors, undoColors } from './webGL';

const THREE = window.THREE;
export var canChangeColor = false;
var selectedColor = false;

export function clearColors(mesh) {
  if (mesh != null && mesh.length > 0) {
    mesh.forEach((element) => {
      if (element.defaultColor != null && element.material != null) {
        element.material.color = element.defaultColor;
        element.overwriteColor = element.material.color;
      }
    });
  }
  // Clear undo/redo history
  undoColors && (undoColors.length = 0);
  redoColors && (redoColors.length = 0);
}

export function clearColorOnly(mesh) {
  // Clear only colors that were applied (from undoColors), keep style and other features
  // Only clear meshes that have been modified with color
  if (undoColors && undoColors.length > 0) {
    undoColors.forEach((action) => {
      if (action.mesh && action.mesh.defaultColor != null) {
        action.mesh.material.color = action.mesh.defaultColor;
        action.mesh.overwriteColor = action.mesh.material.color;
        action.mesh.material.needsUpdate = true;
      }
    });
  }
  // Clear undo/redo history
  undoColors && (undoColors.length = 0);
  redoColors && (redoColors.length = 0);
}

export function updateColor(color) {
  selectedColor = color;
}

export function addColor() {
  console.log('addColor');
  if (selectedColor == null) return;
  if (intersection.mesh == null || intersection.mesh.material == null) {
    return;
  }

  if (intersection.mesh.defaultColor == null) {
    intersection.mesh.defaultColor = intersection.mesh.material.color;
  }
  //updateProduct();
  undoColors.push({
    type: 'color',
    mesh: intersection.mesh,
    value: new THREE.Color(selectedColor.r, selectedColor.g, selectedColor.b),
    current: new THREE.Color(
      intersection.mesh.material.color.r,
      intersection.mesh.material.color.g,
      intersection.mesh.material.color.b,
    ),
    id: intersection?.mesh?.id,
  });
  intersection.mesh.material.color = selectedColor;
  intersection.mesh.overwriteColor = selectedColor;

  redoColors && (redoColors.length = 0);
}

export function doUndoColor() {
  if (undoColors.length > 0) {
    let action = undoColors.pop();
    action.mesh.material.color = action.current;
    action.mesh.overwriteColor = action.mesh.material.color;
    redoColors.push(action);
  }
}

export function doRedoColor() {
  if (redoColors.length > 0) {
    let action = redoColors.pop();
    action.mesh.material.color = action.value;
    action.mesh.overwriteColor = action.mesh.material.color;
    undoColors.push(action);
  }
}

export function enableChangeColor(isEnable) {
  console.log('enableChangeColor');

  canChangeColor = isEnable;
  if (typeof intersection !== 'undefined' && intersection) {
    if (intersection == null) return;
    if (!isEnable) {
      if (intersection?.mesh != null) {
        intersection.mesh.material.emissive.setRGB(0, 0, 0);
      }
    }

    intersection.mesh = null;
  }
}
